import Inputmask from 'inputmask';
import masks from '@/commons/constants/masks';

export default value => {
  if (value) {
    return Inputmask.format(value, masks.BILLET_LINE_CODE);
  }
  return value;
};
